import { Star } from 'lucide-react'
import { toggleStar, useStarred } from '../utils/stars'

/**
 * The star on an animal (plan smartkraal-owner-experience B2): on a wall or feed
 * tile (`variant="overlay"`, over the photo) and in the animal page header
 * (`variant="inline"`). Stars live on this device (utils/stars.js); the wall's
 * "Starred" filter lists them. Rendered beside a tile's link, never inside it.
 */
export default function StarButton({ ranchId, animalId, name = '', variant = 'overlay', className = '' }) {
  const ids = useStarred(ranchId)
  const on = ids.includes(animalId)
  const label = on ? `Unstar ${name}`.trim() : `Star ${name}`.trim()
  const overlay = variant === 'overlay'
  return (
    <button type="button" aria-pressed={on} aria-label={label} title={on ? 'Starred: tap to remove' : 'Star this animal'}
      onClick={() => toggleStar(ranchId, animalId)}
      data-testid="star-button"
      className={`inline-flex items-center justify-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 ${
        overlay ? 'h-7 w-7 bg-black/25 hover:bg-black/40' : 'h-8 w-8 hover:bg-earth-100'} ${className}`}>
      <Star aria-hidden="true" className={`${overlay ? 'h-4 w-4' : 'h-5 w-5'} ${
        on ? 'fill-amber-400 text-amber-400' : overlay ? 'text-white' : 'text-earth-400'}`} />
    </button>
  )
}
